export default function setSingleCookie(key: string,value: string,expiration?: Date, path: string = "/")
{
    document.cookie=`${key}=${value};${expiration ? `expires=${expiration.toUTCString()};` : ""}${path ? `path=${path};` : ""}`;
}